import { useEffect } from 'react';
import { maps } from '~/helpers/api';

const getApiKey = async () => {
  let key;
  try {
    const { keyGoogleMaps } = await maps.googleMapsKey();
    key = keyGoogleMaps;
  } catch (e) {
    return e;
  }

  return key;
};

const useMapsScript = () => {
  useEffect(() => {
    if (!window.google) {
      const script = document.createElement('script');
      getApiKey().then(key => {
        script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places&language=pt-BR`;
        script.async = true;
        script.id = 'vr-maps-script';

        document.body.appendChild(script);
      });
    }
  }, []);
};

export default useMapsScript;
